import React from "react";
import getUtteranceFlagCount from "../../services/getUtteranceFlagCount.js";
import getUtteranceFlagTaggedData from "../../services/getUtteranceFlagTaggedData.js";
import styles from "./UtteranceFlags.module.css";
import { Button } from "@material-ui/core";
import { Table, Switch } from "antd";
import { Link } from "react-router-dom";
import LaunchIcon from "@material-ui/icons/Launch";
import updateUtteranceReviewedStatus from "../../services/updateUtteranceReviewedStatus.js";
import deleteUtteranceFlag from "../../services/deleteUtteranceFlag.js";
import CircularProgress from "@mui/material/CircularProgress";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import StyledFlagChip from "../../assets/components/StyledFlagChip/StyledFlagChip.js";
import BootstrapTooltip from "../../assets/components/BootstrapTooltip.js";
import { Chip } from "@mui/material";

export default function UtteranceFlags(props) {
  const urlParams = new URLSearchParams(window.location.search);
  const category = urlParams.get("category") ? decodeURIComponent(urlParams.get("category")) : "";
  const clientKey = urlParams.get("clientkey") ? decodeURIComponent(urlParams.get("clientkey")) : "";
  const [userInfo, setUserInfo] = React.useState(props?.userInfo);
  const [uttFlags, setUttFlags] = React.useState([]);
  const [setError] = React.useState({
    isError: false,
    msgError: null,
  });
  const [items, setItems] = React.useState([]);
  const [loadingButton, setLoadingButton] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [reviewed, setReviewed] = React.useState(1);
  const [flagModified, setFlagModified] = React.useState(false);
  const [UtteranceFlagFilterEnabled, setUtteranceFlagFilterEnabled] = React.useState("not applied");

  React.useEffect(() => {
    (async () => {
      try {
        if (props.userInfo.userKey !== 0) {
          setUserInfo(props.userInfo);
        }
      } catch (err) {
        setError({
          isError: true,
          msgError: "ERR: Failed to validate user token",
        });
      }
    })();
  }, [props.userInfo.userKey]);

  React.useEffect(() => {
    (async () => {
      try {
        if (props.userInfo.userKey !== 0) {
          setLoadingButton(true);
          let response = await getUtteranceFlagCount(category, clientKey, userInfo.userKey);
          setUttFlags(response?.data?.countUttFlags);
          setLoadingButton(false);
        }
      } catch (err) {
        setError({
          isError: true,
          msgError: "ERR: Failed to getUtteranceFlagCount",
        });
      }
    })();
  }, [reviewed, flagModified]);

  React.useEffect(() => {
    (async () => {
      try {
        if (props.userInfo.userKey !== 0) {
          let response = await getUtteranceFlagTaggedData(category, clientKey, reviewed, currentPage, UtteranceFlagFilterEnabled, userInfo.userKey);
          setItems(response.data);
        }
      } catch (err) {
        setError({
          isError: true,
          msgError: "ERR: Failed to fetch data",
        });
      }
    })();
  }, [currentPage, reviewed, UtteranceFlagFilterEnabled, flagModified]);

  const onReviewChange = (checked) => {
    if (!checked) {
      setReviewed(0);
    } else {
      setReviewed(1);
    }
    setUtteranceFlagFilterEnabled("not applied");
    setCurrentPage(1);
  };

  const handleReviewChange = async (record) => {
    record.UserKey = userInfo.userKey;
    record.FlagIDArr = [record.FlagID];
    await updateUtteranceReviewedStatus(record);
    setFlagModified((prev) => !prev);
  };

  const handleUtteranceFlagDelete = async (record) => {
    record.userKey = userInfo.userKey;
    await deleteUtteranceFlag(record);
    setFlagModified((prev) => !prev);
  };

  const handleUtteranceFlagChange = (event) => {
    setUtteranceFlagFilterEnabled(event.target.value);
    setCurrentPage(1);
  };

  const dropDownFacetValuesForReviewed = uttFlags?.filter((flag) => flag.Reviewed >= 1);

  const dropDownFacetValuesForUnReviewed = uttFlags?.filter((flag) => flag.NotReviewed >= 1 && flag.Count >= 1);

  const columns = [
    {
      title: "S.NO",
      dataIndex: "sno",
      width: "2%",
      render: (text, record, index) => index + 1 + ".",
    },
    {
      title: "File",
      key: "actions",
      width: "2%",
      render: (text, record) => (
        <Link
          target="_blank"
          to={{
            pathname: `/${record.ConversationID}`,
          }}
        >
          <LaunchIcon style={{ fill: "#1976d2" }} />
        </Link>
      ),
    },
    {
      title: "Sentence",
      dataIndex: "Content",
      width: "35%",
    },
    {
      title: "Category",
      dataIndex: "Category",
      width: "15%",
    },
    {
      title: "Subcategory",
      dataIndex: "Subcategory",
      width: "15%",
    },
    {
      title: "Flag",
      dataIndex: "FlagName",
      width: "15%",
      render: (text, record) => {
        return record.Reviewed ? (
          <BootstrapTooltip title="Discard the Utterance" placement="left">
            <div>
              <StyledFlagChip
                isAdmin={true}
                chipText={text.toString()}
                isUtteranceFlag={true}
                isReviewed={record.Reviewed}
                isFastForward={false}
                handleFlagDelete={() => handleUtteranceFlagDelete(record)}
              ></StyledFlagChip>
            </div>
          </BootstrapTooltip>
        ) : (
          <BootstrapTooltip title="Either mark the utterance as reviewed or remove it" placement="left">
            <div>
              <StyledFlagChip
                isAdmin={true}
                chipText={text.toString()}
                isUtteranceFlag={true}
                isReviewed={record.Reviewed}
                isFastForward={false}
                handleFlagDelete={() => handleUtteranceFlagDelete(record)}
                handleFlagReview={() => handleReviewChange(record)}
              ></StyledFlagChip>
            </div>
          </BootstrapTooltip>
        );
      },
    },
  ];

  return (
    <>
      {/* Code for Utterance flag labels */}
      <div className={styles.initialButtons} data-testid="initial-buttons">
        <Link
          to={{
            pathname: "/choice",
            search: "",
          }}
          data-testid="back-link"
        >
          <Button variant="outlined" className={styles.routingButtons} data-testid="back-button">
            <strong>Back</strong>
          </Button>
        </Link>
      </div>
      <div style={{ marginTop: -20, display: "block" }} data-testid="records-for-category">
        <strong>Records for {category}</strong>
      </div>
      <div className={styles.initialContainers} data-testid="initial-containers">
        <div className={styles.flagsContainer} data-testid="flags-container">
          {loadingButton === true ? (
            <CircularProgress size={20} data-testid="loading-flags" />
          ) : uttFlags?.length > 0 ? (
            uttFlags?.map((flag, i) => (
              <React.Fragment key={`${i}_${flag.FlagName}`}>
                <Chip
                  data-testid={`flag-chip-${flag.FlagName}`}
                  label={
                    <>
                      <span>{flag.FlagName} </span>
                      <strong style={{ color: "#0D8244" }}>{flag.Reviewed}</strong>
                      <strong> : </strong>
                      <strong style={{ color: "#1976d2" }}>{flag.NotReviewed}</strong>
                    </>
                  }
                  variant="outlined"
                />
              </React.Fragment>
            ))
          ) : (
            <div className={styles.noReviewedFlags} data-testid="no-reviewed-flags">
              No Utterance Flags are reviewed
            </div>
          )}
        </div>
      </div>
      {/* Code for records section */}
      <div className={styles.UFRecordsContainer} data-testid="uf-records-container">
        <Table
          columns={columns}
          dataSource={items.files}
          bordered
          data-testid="utterance-flags-table"
          title={() => (
            <div className={styles.tableHeader} data-testid="table-header">
              <div className={styles.switch} data-testid="review-switch">
                Unreviewed
                <Switch
                  size="small"
                  style={{ marginLeft: 10, marginRight: 10 }}
                  defaultChecked
                  onChange={onReviewChange}
                  data-testid="reviewed-switch"
                />
                Reviewed
              </div>
              <FormControl sx={{ m: 2, minWidth: 200 }} data-testid="flag-filter-form-control">
                <InputLabel id="model-category-select">Utterance Flag</InputLabel>
                <Select
                  labelId="model-category-select"
                  id="model-category"
                  label="Utterance flag"
                  value={UtteranceFlagFilterEnabled === "not applied" ? "" : UtteranceFlagFilterEnabled}
                  onChange={handleUtteranceFlagChange}
                  data-testid="flag-filter-select"
                >
                  <MenuItem key="NA" value="not applied" data-testid="flag-filter-na">
                    NA
                  </MenuItem>

                  {reviewed === 1
                    ? dropDownFacetValuesForReviewed?.map((options, i) => (
                        <MenuItem key={i} value={options.FlagName} data-testid={`flag-filter-option-${options.FlagName}`}>
                          {options.FlagName}
                        </MenuItem>
                      ))
                    : dropDownFacetValuesForUnReviewed?.map((options, i) => (
                        <MenuItem key={i} value={options.FlagName} data-testid={`flag-filter-option-${options.FlagName}`}>
                          {options.FlagName}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </div>
          )}
          pagination={{
            total: items.totalCount,
            simple: true,
            current: currentPage,
            onChange: (page) => {
              setCurrentPage(page);
            },
          }}
        />
      </div>
    </>
  );
}
